export default __webpack_public_path__ + "media/images/about-bg-4b78ec281159564bf07e5e2bfad8af5b.jpg";